import { Injectable, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { removeTags } from '../utils/utils';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  private readonly metaTagService = inject(Meta);

  updateMetaTags(
    description: string,
    title: string,
    url: string,
    type?: string,
    image?: string,
    imageWidth?: number,
    imageHeigt?: number,
    imageType?: string,
    publishedTime?: string,
    modifiedTime?: string
  ): void {
    this.metaTagService.updateTag({
      name: 'description',
      content: removeTags(description),
    });
    this.metaTagService.updateTag({
      property: 'og:description',
      content: removeTags(description),
    });
    this.metaTagService.updateTag({
      property: 'og:title',
      content: removeTags(title),
    });
    this.metaTagService.updateTag({ property: 'og:url', content: url });

    if (type) {
      this.metaTagService.updateTag({
        property: 'og:type',
        content: type,
      });
    }

    if (publishedTime) {
      this.metaTagService.updateTag({
        property: 'article:published_time',
        content: publishedTime,
      });
    }

    if (modifiedTime) {
      this.metaTagService.updateTag({
        property: 'article:modified_time',
        content: modifiedTime,
      });
    }

    if (image) {
      this.metaTagService.updateTag({
        property: 'og:image',
        content: image,
      });
      this.metaTagService.updateTag({
        property: 'og:image:width',
        content: '' + imageWidth,
      });
      this.metaTagService.updateTag({
        property: 'og:image:height',
        content: '' + imageHeigt,
      });
      this.metaTagService.updateTag({
        property: 'og:image:type',
        content: imageType ?? 'image/png',
      });
    }
  }

  removeTag(tag: string): void {
    this.metaTagService.removeTag(tag);
  }
}
